import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { MmButtonModule, MmDialogModule, MmIconModule } from '@metromarkets/components';

import { AddressesModule } from '~shared/modules/addresses/addresses.module';
import { AdvancedFormModule } from '~shared/modules/advanced-form/advanced-form.module';
import { MediaControlModule } from '~shared/modules/media-control/media-control.module';
import { AddressBookComponent } from './components/address-book/address-book.component';
import { AddressesComponent } from './components/addresses/addresses.component';
import { CreateAddressComponent } from './components/create-address/create-address.component';
import { EditAddressComponent } from './components/edit-address/edit-address.component';
import { RemoveAddressDialogComponent } from './components/remove-address-dialog/remove-address-dialog.component';
import { AddressBookService } from './services/address-book.service';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MmButtonModule,
    MmDialogModule,
    MmIconModule,
    QaLocatorsModule,
    AddressesModule,
    AdvancedFormModule,
    MediaControlModule,
    TranslateModule,
  ],
  declarations: [
    AddressBookComponent,
    AddressesComponent,
    CreateAddressComponent,
    EditAddressComponent,
    RemoveAddressDialogComponent,
  ],
  providers: [
    AddressBookService
  ]
})
export class AddressBookModule {}
